import React, { useState } from "react";
import { Button, Box, } from "@mui/material";
import AdminHeader from "../components/HeadComp/AdminHeader";
import CustomerRequests from "./CustomerRequests";
import SearchByID from "./SearchByID";

const AdminDashboard = () => {
  const [customerData, setCustomerData] = useState(true);
  const [customerButton, setCustomerButton] = useState(true);
  const [empData, setEmpData] = useState(false);
  const [empButton, setEmpButton] = useState(false);

  return (
    <Box>
      <AdminHeader />
      <Box sx={{ height: "10vh" }}></Box>
      <Box sx={{
        display:"flex", justifyContent:"space-evenly"
      }}>
        <Button
          variant="contained"
          onClick={() => { setCustomerData(true); setEmpData(false); setCustomerButton(true); setEmpButton(false) }}
          disabled={customerButton}
        >Customer Requests</Button>

        <Button
          variant="contained"
          onClick={() => { setCustomerData(false); setEmpData(true); setEmpButton(true); setCustomerButton(false) }}
          disabled={empButton}
        >Employee Requests</Button>
      </Box>
      {
        customerData && <CustomerRequests />
      }
      {
        empData && <SearchByID />
      }
    </Box>
  );
};

export default AdminDashboard;